module.exports = __webpack_public_path__ + "img/old_1_thumb.12bead63.jpg";